<!--
Author: TangChen
Date: 2018-09-17
Desc: 用户信息展示组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-welcome bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="accountInfo">
            <el-col :span="14" class="circle-bg">
                <div class="act-info clear">
                    <img
                        v-if="info.headimage && (info.headimage || '').indexOf('http') === -1"
                        class="act-img"
                        :src="$util.fileDownloadPath(info.headimage)"
                        alt=""
                    />
                    <img
                        v-else
                        class="act-img"
                        :src="require('../../assets/img/account-img.png')"
                        alt=""
                    />
                    <div class="act-basic">
                        <div class="user-info">
                            <p class="name">
                                欢迎您，
                                <span
                                    class="k-text-flow"
                                    :class="{ mobilet: !info.custname }"
                                    :title="
                                        info.custname
                                            ? info.custname
                                            : $util.desensitizePhoneNumber(info.mobileno)
                                    "
                                >
                                    {{
                                        info.custname
                                            ? info.custname
                                            : $util.desensitizePhoneNumber(info.mobileno)
                                            ? $util.desensitizePhoneNumber(info.mobileno)
                                            : info.certificateno
                                    }}
                                </span>
                            </p>
                            <div class="info-lists">
                                <span
                                    class="act-bg"
                                    :class="{
                                        'is-ok': info.mobileno.length === 11
                                    }"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="
                                            info.mobileno.length === 11
                                                ? '您的手机已绑定，号码为：' +
                                                  $util.desensitizePhoneNumber(info.mobileno)
                                                : '您还未绑定手机号，请立即前往'
                                        "
                                        placement="top"
                                    >
                                        <el-button class="act-info-btn" v-on:click="toHxEdit">
                                            <i
                                                class="fa fa-mobile"
                                                style="font-size: 18px"
                                                aria-hidden="true"
                                            />
                                        </el-button>
                                    </el-tooltip>
                                </span>
                                <span class="act-bg" :class="{ 'is-ok': info.totalcardnum > 0 }">
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="
                                            info.totalcardnum > 0
                                                ? '您已绑定' + info.totalcardnum + '张银行卡'
                                                : '您还未绑定银行卡，请立即前往'
                                        "
                                        placement="top"
                                    >
                                        <el-button
                                            class="act-info-btn"
                                            v-on:click="
                                                $router.push({
                                                    name: 'bank'
                                                })
                                            "
                                        >
                                            <i class="fa fa-credit-card" aria-hidden="true" />
                                        </el-button>
                                    </el-tooltip>
                                </span>
                                <span
                                    class="act-bg"
                                    :class="{
                                        'is-ok': info.riskexpired === '0'
                                    }"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="
                                            info.riskexpired === '0'
                                                ? '您的风险等级为：' +
                                                  $cache.getDict('100017', info.risklevel)
                                                : (info.risklevel && info.risklevel.trim()
                                                      ? '你的风险评测已过期，当前风险' +
                                                        $cache.getDict('100017', info.risklevel)
                                                      : '您还未做风险评测') + '，请立即评测'
                                        "
                                        placement="top"
                                    >
                                        <el-button
                                            class="act-info-btn"
                                            v-on:click="$router.push({ name: 'risk' })"
                                        >
                                            <i class="fa fa-umbrella" aria-hidden="true" />
                                        </el-button>
                                    </el-tooltip>
                                </span>
                                <span
                                    v-if="!$util.getConfig().userinfoHide"
                                    class="act-bg"
                                    :class="{
                                        'is-ok': info.needfillappro === '0'
                                    }"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="
                                            info.needfillappro === '0'
                                                ? '您的适当性信息已完善'
                                                : '您的适当性信息尚未补录，请立即前往'
                                        "
                                        placement="top"
                                    >
                                        <el-button
                                            class="act-info-btn"
                                            v-on:click="
                                                $router.push({
                                                    name: 'infocollection'
                                                })
                                            "
                                        >
                                            <i class="fa fa-pencil-square" aria-hidden="true" />
                                        </el-button>
                                    </el-tooltip>
                                </span>
                                <span
                                    v-if="!$util.getConfig().userinfoHide"
                                    class="act-bg"
                                    :class="{
                                        'is-ok': info.needfillcrs === '0'
                                    }"
                                >
                                    <el-tooltip
                                        class="item"
                                        effect="info"
                                        :content="
                                            info.needfillcrs === '0'
                                                ? '您的CRS信息已完善'
                                                : '您的CRS信息尚未录入，请立即前往'
                                        "
                                        placement="top"
                                    >
                                        <el-button
                                            class="act-info-btn"
                                            v-on:click="
                                                $router.push({
                                                    name: 'taxeslist'
                                                })
                                            "
                                        >
                                            <i class="fa fa-id-badge" aria-hidden="true" />
                                        </el-button>
                                    </el-tooltip>
                                </span>
                            </div>
                        </div>
                        <div class="investor">
                            <span>完善信息：</span>
                            <el-progress :stroke-width="10" :percentage="perfect" color="#1479d7" />
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
            </el-col>
            <el-col :span="10">
                <div class="login-info">
                    <!-- <p v-if="info.lastlogintime && info.lastlogintime !== '0'" class="login-time">
                        上次登录时间：
                        <span>{{ info.lastlogintime }}</span>
                    </p> -->
                    <p class="login-time">
                        投资者类型：
                        <span v-if="info.professionflag">{{ getRiskDesc(info, nowDate) }}</span>
                    </p>
                    <p v-if="info.risklevel" class="login-time">
                        风险等级：
                        <span>
                            {{
                                "C" +
                                info.risklevel +
                                "(" +
                                $cache.getDict("100017", info.risklevel).replace("承受能力", "") +
                                "风险)"
                            }}
                        </span>
                    </p>
                    <!-- <p
                        v-if="
                            info.custname &&
                            $cache.getBinded() &&
                            !$util.getConfig().onlyPrivateFund &&
                            showTodo
                        "
                        class="todo-info"
                    >
                        <span class="notice-box">
                            <img
                                width="12px"
                                height="12px"
                                :src="require('../../assets/img/notice.png')"
                                alt=""
                            />
                            <span class="tip">您有待办事项未处理</span>
                            <span class="go" v-on:click="goTodo">查看</span>
                            <i
                                class="el-icon-close close"
                                aria-hidden="true"
                                v-on:click="closeTodo"
                            ></i>
                        </span>
                    </p> -->
                    <!-- <p
                        v-if="
                            info.custname &&
                            $cache.getBinded() &&
                            !$util.getConfig().onlyPrivateFund &&
                            showTodo
                        "
                        class="open-info"
                    >
                        <el-tooltip
                            class="item"
                            effect="info"
                            content="“预留信息”是为了帮助您有效识别网上交易系统，防范不法分子利用假网站进行诈骗的一项服务，您可以预先记录一段文字(即“预留信息”)，当登录系统时，网页上会自动显示您的预留信息，以便您确认是否真实的网上交易系统。"
                            placement="top"
                        >
                            <i class="el-icon-question" aria-hidden="true" />
                        </el-tooltip>
                        <span class="grey remark">预留信息：</span>
                        <span
                            class="all-info k-text-flow"
                            v-on:click="remarkShow = true"
                            v-text="
                                info.remark && info.remark.trim() !== ''
                                    ? info.remark
                                    : '您未设置预留信息'
                            "
                        />
                    </p> -->
                    <!-- <p
                        v-if="!$cache.getBinded() && !$util.getConfig().onlyPrivateFund"
                        class="open-info"
                    >
                        您还未绑定账户，
                        <span
                            v-on:click="
                                !$cache.getBinded()
                                    ? $router.push('/securitycenter/bindnewacct')
                                    : $router.push('/securitycenter/bindacctway')
                            "
                        >
                            立即绑定账户
                        </span>
                        ，开启基金之旅
                    </p> -->
                </div>
            </el-col>
        </el-row>
        <el-dialog
            :title="(info.remark && info.remark !== ' ' ? '修改' : '新增') + '预留信息'"
            :visible.sync="remarkShow"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="100px"
                    size="small"
                >
                    <el-form-item label="预留信息：" prop="remark">
                        <el-input
                            v-model="ruleForm.remark"
                            type="text"
                            :maxlength="64"
                            placeholder="请输入预留信息"
                        />
                    </el-form-item>
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <!--                        <span-->
                        <!--                            class="redemp-btn"-->
                        <!--                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                        <!--                        >-->
                        <!--                            <span class="like-a">忘记密码？</span>-->
                        <!--                        </span>-->
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="addRemark">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import userApi from "@/api/user";

export default {
    name: "WelcomeInfo",
    mixins: [mixin],
    data() {
        return {
            infoPer: 0, // 信息完善进度
            info: {
                mobileno: ""
            },
            showTodo: true, // 是否显示代办
            nowDate: "", // 当前时间
            remarkShow: false,
            isPwdCheck: false,
            // 撤单密码校验
            ruleForm: {
                tradepwd: "",
                remark: ""
            },
            rules: {
                remark: [
                    {
                        required: true,
                        message: "请输入预留信息",
                        trigger: "blur"
                    }
                ],
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    computed: {
        // 计算属性的 getter
        perfect: function () {
            const a = ["mobileno", "totalcardnum", "riskexpired", "needfillappro", "needfillcrs"];
            let x = 0;
            for (let i of a) {
                if (
                    (this.info[i] === "0" && i !== "totalcardnum") ||
                    (i === "totalcardnum" && this.info[i] > 0) ||
                    (i === "mobileno" &&
                        ((this.$cache.getBinded() && this.info.custname) ||
                            (this.info.mobileno && !this.info.custname)))
                ) {
                    x++;
                }
            }
            return (x * 100) / a.length;
        }
    },
    watch: {
        "$store.state.user.info": {
            handler(newValue, oldValue) {
                this.initData();
            },
            deep: true // 启用深度监听
        }
    },
    mounted() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        // 修改用户信息接口不支持校验交易密码
        // this.isPwdCheck = this.$cache.getPwdCheck("B1");
        this.initData();
    },

    methods: {
        initData() {
            this.info = this.$cache.getUser();
            this.info.headimage = this.$cache.getHeadImage();
            setTimeout(() => {
                this.queryValidPwdTrdMethod();
                const _this = this;
                if (
                    this.$cache.getBinded() &&
                    this.$store.state.user.info &&
                    this.$store.state.user.info.custname
                ) {
                    this.$util.getProfession((data) => {
                        _this.info = Object.assign({}, _this.info, data);
                    });
                }
            }, 200);
        },
        // 新增或修改预留信息
        addRemark() {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    _this.acctInfo = this.$cache.getUser();
                    let _obj = Object.assign({}, _this.acctInfo);
                    // let _obj = _this.$util.getObjParam(
                    //     _this.acctInfo,
                    //     "validdate,specialpersonflag,nationality,vocationcode,delivertype,deliverway,sex,educationlevel,postcode,email,telno,telareacode,telcycode,fax,faxcycode,faxareacode,address,livingaddress,remark,birthday,pwd,benefisself,livingaddressprovince,livingaddresscity,livingaddresscounty,assetssource,benefitname,benefitcertificatetype,benefitcertificateno,benefitvaliddate,benefitsex,benefitbirthday," +
                    //         "benefitvocation,benefittelnocycode,benefittelnoareacode,benefittelno,benefitcountry,benefitaddressprovince,benefitaddresscity,benefitaddresscounty," +
                    //         "benefitaddress,benefitemail,benefitpostcode,benefrelation,actualisself,actualctrlname,actualctrlcertype,actualctrlcerno,actualctrlvalidate,actualctrlsex,actualctrlbirthday,actualctrlvocation," +
                    //         "actelnocycode,actelnoareacode,actualctrltelno,actualctrlcountry,actualctrladdrprovince,actualctrladdrcity,actualctrladdrcounty,actualctrladdr,actualctrlemail,actualctrlpostcode,actualrelation,tradingmethod"
                    // );
                    _obj.remark = _this.ruleForm.remark;
                    _obj.tradepwd = _pwd;
                    const reqRes = await userApi.updAcctInfo(_obj);
                    const res = reqRes.data;
                    if (res.appsheetserialno) {
                        _this.remarkShow = false;
                        _this.info.remark = _this.ruleForm.remark;
                        let _x = Object.assign({}, _this.info);
                        _this.$store.dispatch("setInfo", _x).then(() => {});
                    }
                } else {
                    return false;
                }
            });
        },
        async queryValidPwdTrdMethod() {
            this.isPwdCheck = this.$cache.getPwdCheck("B1");
        },
        getRiskDesc(info, nowDate) {
            return (
                (info.professionflag
                    ? this.$cache.getDict("120051", info.professionflag)
                    : "未知") +
                (info.professionflag === "1" && info.effectdate <= nowDate ? "(已过期)" : "")
            );
        },
        goTodo() {
            console.log("跳转到代办");
        },
        closeTodo() {
            this.showTodo = false;
        },
        async toHxEdit() {
            const changeMobile = this.$util.getConfig().hxUrl.changeMobile;
            window.open(changeMobile, "_blank");
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/* 用户信息 */
.bizcomp-welcome {
    .investor-tips {
        padding-top: 20px;
        .el-form-item {
            margin-bottom: 18px !important;
        }
    }
    .redemp-btn {
        margin-left: 3%;
    }
    .accountInfo {
        .login-info {
            padding: 19px 10px 19px 30px;
            p {
                line-height: 36px;
                color: $text-color1;
                &.login-time {
                    color: #666666;
                    span {
                        font-size: 16px;
                        font-weight: 500;
                        color: #333333;
                    }
                }
                &.todo-info {
                    .notice-box {
                        padding: 4px 8px;
                        border-radius: 6px;
                        font-size: 14px;
                        font-weight: normal;
                        box-sizing: border-box;
                        border: 1px solid #d9d9d9;
                        color: #666666;
                        .tip {
                            margin: 0 4px;
                        }
                        .go {
                            cursor: pointer;
                            color: #1890ff;
                            margin-right: 32px;
                        }
                        .close {
                            cursor: pointer;
                        }
                    }
                }
                &.open-info {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    .el-button.act-info-btn {
                        padding: 0;
                        border: 0;
                        border-radius: 100%;
                        margin-right: 5px;
                    }
                    i {
                        color: $color-b;
                        vertical-align: middle;
                        font-style: normal;
                        &.grey {
                            color: $text-color3;
                        }
                    }
                    span {
                        color: $color-b;
                        cursor: pointer;
                        &.all-info {
                            width: 70%;
                            display: inline-block;
                            height: 36px;
                            vertical-align: middle;
                        }
                        &:hover {
                            color: $color-a;
                        }
                    }
                    .remark {
                        color: $text-color3;
                        cursor: text;
                        &:hover {
                            color: $text-color3;
                        }
                    }
                }
            }
        }
        .act-info {
            padding: 19px 0;
            .act-img {
                margin-left: 16px;
                margin-top: 10px;
                width: 50px;
                height: 50px;
                float: left;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                overflow: hidden;
            }
            .act-basic {
                float: left;
                color: $text-color2;
                line-height: 24px;
                padding-left: 20px;
                p,
                .info-lists,
                .el-progress.el-progress--line {
                    display: inline-block;
                    vertical-align: middle;
                }
                .investor {
                    line-height: 24px;
                    color: $text-color2;
                    span {
                        vertical-align: middle;
                    }
                    .el-progress.el-progress--line {
                        .el-progress-bar {
                            width: 340px;
                        }
                        .el-progress__text {
                            color: $color-b;
                            font-size: $f14 !important;
                        }
                    }
                }
                .info-lists {
                    .act-bg {
                        margin-right: 14px;
                        display: inline-block;
                        vertical-align: middle;
                        span {
                            display: inline-block;
                            vertical-align: middle;
                            height: 24px;
                        }
                        &:last-child {
                            margin: 0;
                        }
                        .el-button.act-info-btn {
                            padding: 0;
                            border: 0;
                            border-radius: 100%;
                        }
                        i {
                            width: 24px;
                            height: 24px;
                            display: inline-block;
                            border-radius: 100%;
                            background: $bg9;
                            color: $text-color6;
                            font-size: $f16;
                            text-align: center;
                            line-height: 24px;
                        }
                        &.is-ok i {
                            background: $color-a;
                        }
                    }
                }
                .user-info {
                    line-height: 40px;
                    .name span {
                        font-size: $f24;
                        width: 160px;
                        display: inline-block;
                        vertical-align: middle;
                        &.mobilet {
                            font-size: $f18;
                        }
                    }
                }
            }
            .line {
                float: right;
                width: 0px;
                height: 88px;
                border: 1px dashed #d9d9d9;
            }
        }
    }
}
</style>
